import dayjs from 'dayjs'

import { DataPoint } from 'src/components/molecules/HistoryGraph'

import { GetDashboardDataQuery } from 'src/config/generated/graphql'
import { ArrayElement } from 'src/types/common'

export const buildFunderGraphData = (dashboardData?: GetDashboardDataQuery) => {
  if (!dashboardData?.FunderStatsForUser) return []

  return dashboardData?.FunderStatsForUser.filter(
    a => Number(a.SeasonName) >= a.AccountYearJoined
  )
    .reduce(
      (
        funderStatsData: DataPoint[],
        funderStat: ArrayElement<GetDashboardDataQuery['FunderStatsForUser']>
      ) => {
        if (
          funderStat.SeasonName !== 'All' &&
          dayjs().year() >= Number.parseInt(funderStat.SeasonName)
        ) {
          return [
            ...funderStatsData,
            {
              xAxis: funderStat.SeasonName,
              yAxis: funderStat.TreesFunded
            }
          ]
        }

        return funderStatsData
      },
      []
    )
    .sort((a: DataPoint, b: DataPoint) =>
      `${a.xAxis}`.localeCompare(`${b.xAxis}`)
    )
}

export const buildPlanterGraphData = (
  dashboardData?: GetDashboardDataQuery
) => {
  if (!dashboardData?.PlanterStatsForUser) return []

  return dashboardData?.PlanterStatsForUser.filter(
    a => Number(a.SeasonName) >= a.AccountYearJoined
  )
    .reduce(
      (
        planterStatsData: DataPoint[],
        planterStat: ArrayElement<GetDashboardDataQuery['PlanterStatsForUser']>
      ) => {
        if (planterStat.SeasonName !== 'All') {
          return [
            ...planterStatsData,
            {
              xAxis: planterStat.SeasonName,
              yAxis: planterStat.TreesApproved
            }
          ]
        }

        return planterStatsData
      },
      []
    )
    .sort((a: DataPoint, b: DataPoint) =>
      `${a.xAxis}`.localeCompare(`${b.xAxis}`)
    )
}

export const getAllTimeTreesFunded = (dashboardData?: GetDashboardDataQuery) =>
  dashboardData?.FunderStatsForUser.find(
    (funderStat: ArrayElement<GetDashboardDataQuery['FunderStatsForUser']>) =>
      funderStat.SeasonName === 'All'
  )?.TreesFunded || 0
